module.exports = function (v1, v2) {
  return v1 === v2;
};
